import _ from "lodash";
import { getUserType } from "modules/CommonSelectors";
import { DISPLAY_OPTIONS } from "./Constants";
import { STANDARD_BASED_RUBRIC } from "Constants/stringConstants";
import ACLStore from "lib/aclStore";

export const getDisplayOptions = ({ t, type }) => {
  return _.map(DISPLAY_OPTIONS[type], option => ({
    ...option,
    label: t(option.label),
  }));
};

export const getRowId = id => `SCORE_BASED_RUBRIC_CRITERIA_${id}`;
export const getColumnId = id => `SCORE_BASED_RUBRIC_INDICATOR_${id}`;

// Common helper function to check if a cell is evaluated
export const isEvaluated = (responses, rowId, columnId) => {
  return (
    _.findIndex(
      responses,
      response =>
        _.get(response, "rowId") === rowId &&
        _.get(response, "columnId") === columnId &&
        !response?.isDeleted
    ) >= 0
  );
};

export const getCalculatedScore = params => {
  const {
    toolResponses,
    assessmentTool,
    creatorType = "STAFF",
    ibPYPElementRatings,
    isAiEvaluationEnabled,
  } = params;

  const userType = getUserType();

  if (!_.isEmpty(ibPYPElementRatings)) {
    const score = _.find(ibPYPElementRatings, {
      ibPYPElementType: "SCORE",
      creatorType: "STAFF",
    });
    return _.get(score, "value", null);
  }

  const calculatedScore = _.reduce(
    toolResponses,
    (total, response) => {
      // Find the criteria that matches the response rowId
      const criteria = _.find(
        assessmentTool.standardRubricCriterias,
        criteria => criteria.id === response.rowId
      );

      const shouldExcludeFromTotal =
        isAiEvaluationEnabled &&
        response?.creatorType === "AI" &&
        userType === "staff"
          ? response?.isDeleted
          : response?.creatorType !== creatorType;

      if (_.isEmpty(criteria) || shouldExcludeFromTotal) return total;

      // Find the descriptor that matches the response columnId
      const descriptor = _.find(
        criteria.descriptors,
        descriptor => descriptor.id === response.columnId
      );

      // Add the descriptor score to the total
      return total + (descriptor ? descriptor.score : 0);
    },
    0
  );

  return _.toString(_.round(calculatedScore, 2));
};

export const getElementType = criterion => {
  return _.get(criterion, "standard.standardsWrapper.standardSet.type");
};

export const getIsGradeScaleValueSelectionAllowed = type => {
  return (
    type === STANDARD_BASED_RUBRIC &&
    ACLStore.can("FeatureFlag:AllowLabelChangeInStandardRubric")
  );
};

// Transform criteria to replace standard with benchmark if standard is null but benchmark exists
export const getTransformedAssessmentTool = assessmentTool => {
  if (_.isNil(assessmentTool)) return assessmentTool;

  const criteria = _.get(assessmentTool, "standardRubricCriterias", []);

  const transformedCriteria = _.map(criteria, criterion => {
    const hasNoStandard = _.isNil(_.get(criterion, "standard"));
    const hasBenchmark = !_.isNil(_.get(criterion, "benchmark"));

    if (hasNoStandard && hasBenchmark) {
      return {
        ...criterion,
        standard: _.get(criterion, "benchmark"),
      };
    }

    return criterion;
  });

  return {
    ...assessmentTool,
    standardRubricCriterias: transformedCriteria,
  };
};
